import { useState } from 'react'
import { mockModelButtonLabel } from './mockModelLabels'
import { useMockModelStore } from './mockModelStore'

const store = useMockModelStore.getState

/**
 * Wires DO Mek and Custom into the model picker. A preview choice sends `auto`
 * to the backend (if it isn't already the model) so chats keep working;
 * picking any real model clears the preview choice.
 */
export function useMockModelPicker({ selection, onChange, close }) {
  const choice = useMockModelStore((s) => s.choice)
  const custom = useMockModelStore((s) => s.custom)
  const [dialogOpen, setDialogOpen] = useState(false)
  const fallBackToAuto = () => {
    if (selection.selectedId !== 'auto') onChange?.('auto')
  }
  return {
    choice,
    custom,
    dialogOpen,
    label: mockModelButtonLabel(choice, custom),
    // Real rows compare against this id, so none of them reads as selected.
    selection: choice ? { ...selection, selectedId: `mock:${choice}` } : selection,
    selectReal: (value) => { store().clearChoice(); onChange?.(value); close() },
    chooseDoMek: () => { store().chooseDoMek(); fallBackToAuto(); close() },
    openCustom: () => { close(); setDialogOpen(true) },
    closeCustom: () => setDialogOpen(false),
    saveCustom: (next) => { store().saveCustom(next); fallBackToAuto(); setDialogOpen(false) },
    removeCustom: () => { store().removeCustom(); setDialogOpen(false) },
  }
}
